<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Export Member Bank Detail Report</h5>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col sm="4">
                <label class="mr-sm-2" for="sStartTime">From (yyyy/mm/dd 00:00:00)</label>
                <b-input id="sStartTime" type="date" placeholder="" v-model.trim="sStartTime" :state="$v.sStartTime.$error?false:null" @blur.native="$v.sStartTime.$touch"></b-input>
                <div v-if="$v.sStartTime.$error">
                  <div class="invalid-feedback d-block" v-if="!$v.sStartTime.required">Start Time is required</div>
                  <div class="invalid-feedback d-block" v-if="!$v.sStartTime.rangeInvalid">Date Range should be or below 3 months</div>
                </div>
              </b-col>
              <b-col sm="4">
                <label class="mr-sm-2" for="sEndTime">To (yyyy/mm/dd 23:59:59)</label>
                <b-input id="sEndTime" type="date" placeholder="" v-model.trim="sEndTime" :state="$v.sEndTime.$error?false:null" @blur.native="$v.sEndTime.$touch"></b-input>
                <div v-if="$v.sEndTime.$error">
                  <div class="invalid-feedback d-block" v-if="!$v.sEndTime.required">Start Time is required</div>
                  <div class="invalid-feedback d-block" v-if="!$v.sEndTime.rangeInvalid">Date Range should be or below 3 months</div>
                </div>
              </b-col>
              <b-col sm="4" class="align-self-end">
                <b-button id="sBtn" variant="primary" @click="exportReport" :disabled="$v.sStartTime.$invalid || $v.sEndTime.$invalid"><i class="fa fa-search"></i> Export</b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  import moment from 'moment-timezone'
  const {required} = require('vuelidate/lib/validators')
  export default {
    name: 'withdraw-whitelist-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        sStartTime: moment().tz('Asia/Taipei').subtract({ days: 1 }).format('YYYY-MM-DD'),
        sEndTime: moment().tz('Asia/Taipei').subtract({ days: 1 }).format('YYYY-MM-DD')
      }
    },
    validations: {
      sStartTime: {
        required,
        rangeInvalid: function () {
          return this.validateDateRange()
        }
      },
      sEndTime: {
        required,
        rangeInvalid: function () {
          return this.validateDateRange()
        }
      }
    },
    methods: {
      validateDateRange () {
        let from = moment(this.sStartTime)
        let to = moment(this.sEndTime)
        let duration = moment.duration(to.diff(from))
        let monthsRange = duration.asMonths()
        return !(Math.abs(monthsRange) > 3)
      },
      exportReport () {
        let url = `/report/member/memberBank/export?startDate=${this.sStartTime}&endDate=${this.sEndTime}`
        this.$http.get(this.API_ENDPOINT + url, {responseType: 'blob', headers: { 'Content-Type': 'application/json' }}).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `member_bank_detail_report_${moment(this.sStartTime).format('YYYYMMDD')}_${moment(this.sEndTime).format('YYYYMMDD')}.csv`)
          document.body.appendChild(link)
          link.click()
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/report/member/MemberBankReportTable.vue